// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1z9Z3","question":"Question_question__j2TEv","description":"Question_description__30_B2"};